<template>
  <div class="personal-center">
    <header>
      <button @click="load">
        <img
          src="../images/ban/refresh.png"
          alt=""
        >
      </button>
      <h1>{{ $t('shop.personalCenter') }}</h1>
      <button @click="openDrawer">
        <van-icon
          name="wap-nav"
          size="20"
        />
      </button>
    </header>
    <section class="profile">
      <div class="profile-content">
        <div class="profile-identity">
          <img
            src="../images/home/headDefault.png"
            alt=""
          >
          <p class="profile-user">
            <span>{{ $t('shop.username') }}</span><strong>{{ data.name || data.mobile }}</strong>
          </p>
        </div>
        <div class="profile-details">
          <p><span>{{ $t('shop.balance') }}</span><strong>{{ money(data.money) }}</strong></p>
          <p><span>{{ $t('shop.frozenAmount') }}</span><strong>{{ money(data.frozenmoney) }}</strong></p>
          <p><span>{{ $t('shop.reputationPoints') }}</span><strong>{{ data.credit || 0 }}</strong></p>
          <p><span>{{ $t('shop.vip') }}</span><strong>{{ data.vip_name || '--' }}</strong></p>
        </div>
      </div>
    </section>
    <section class="wallet-actions">
      <button @click="$router.push('/kefu')">
        <img
          src="../images/ban/recharge.png"
          alt=""
        ><span>{{ $t('shop.recharge') }}</span>
      </button>
      <button @click="$router.push('/cash')">
        <img
          src="../images/ban/withdraw.png"
          alt=""
        ><span>{{ $t('shop.withdraw') }}</span>
      </button>
    </section>
    <section class="menu order-menu">
      <button
        v-for="item in orderEntries"
        :key="item.text"
        @click="$router.push(item.path)"
      >
        <img
          v-if="item.icon"
          :src="item.icon"
          alt=""
        >
        <van-icon
          v-else
          class="entry-icon"
          :name="item.iconName"
        />
        <span>{{ item.text }}</span><van-icon name="arrow" />
      </button>
    </section>
    <section class="menu record-menu">
      <button
        v-for="item in fundEntries"
        :key="item.text"
        @click="$router.push(item.path)"
      >
        <img
          :src="item.icon"
          alt=""
        ><span>{{ item.text }}</span><van-icon name="arrow" />
      </button>
    </section>
    <section class="menu support">
      <button
        v-for="item in support"
        :key="item.text"
        @click="$router.push(item.path)"
      >
        <img
          :src="item.icon"
          alt=""
        ><span>{{ item.text }}</span><van-icon name="arrow" />
      </button>
    </section>
    <div
      v-if="drawerOpen"
      class="drawer-mask"
      @click.self="closeDrawer"
    >
      <aside class="account-drawer">
        <button
          class="drawer-close"
          :aria-label="$t('utils.cancel')"
          @click="closeDrawer"
        >
          <van-icon name="cross" />
        </button>
        <button
          v-for="item in drawerItems"
          :key="item.text"
          class="drawer-item"
          @click="handleDrawer(item)"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <span>{{ item.text }}</span>
          <van-icon name="arrow" />
        </button>
      </aside>
    </div>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';

export default {
    data() {
        return { data: {}, drawerOpen: false };
    },
    computed: {
        records() {
            return [
                { text: this.$t('shop.order'), path: '/orderhis', icon: require('../images/ban/orderlist.png') },
                { text: this.$t('shop.favorites'), path: '/favorites', iconName: 'like-o' },
                { text: this.$t('shop.withdrawalRecords'), path: '/withdrawRecord', icon: require('../images/ban/withdrawr.png') },
                { text: this.$t('shop.rechargeRecord'), path: '/rechargeRecord', icon: require('../images/ban/recharger.png') },
                { text: this.$t('shop.fundRecords'), path: '/moneybag', icon: require('../images/ban/fund.png') },
                { text: this.$t('shop.invite'), path: '/teamhis', icon: require('../images/ban/yao.png') }
            ];
        },
        support() {
            return [
                { text: this.$t('shop.customerService'), path: '/kefu', icon: require('../images/ban/service.png') },
                { text: this.$t('shop.helpCenter'), path: '/about', icon: require('../images/ban/qs.png') }
            ];
        },
        orderEntries() {
            return this.records.slice(0, 2);
        },
        fundEntries() {
            return this.records.slice(2);
        },
        drawerItems() {
            return [
                { text: this.$t('shop.bankCard'), path: '/account', icon: require('../images/ban/bind.png') },
                { text: this.$t('shop.shippingAddress'), path: '/shippingAddress', icon: require('../images/ban/shipping.png') },
                { text: this.$t('shop.changePassword'), path: '/setpwd', icon: require('../images/ban/psw.png') },
                { text: this.$t('shop.changePaymentPassword'), path: '/setpaypwd', icon: require('../images/ban/paypsw.png') },
                { text: this.$t('shop.quit'), action: 'logout', icon: require('../images/ban/quit.png') }
            ];
        }
    },
    mounted() {
        this.$parent.footer('user');
        this.load();
    },
    methods: {
        money(value) {
            return this.$formatPen(value || '0');
        },
        load() {
            Fetch('/user/info', {}, null, true).then((res) => {
                this.data = res.data || {};
            });
        },
        openDrawer() {
            this.drawerOpen = true;
        },
        closeDrawer() {
            this.drawerOpen = false;
        },
        handleDrawer(item) {
            this.closeDrawer();
            if (item.action === 'logout') {
                localStorage.removeItem('token');
                this.$router.replace('/');
                return;
            }
            this.$router.push(item.path);
        }
    }
};
</script>

<style scoped>
.personal-center { min-height: 100vh; box-sizing: border-box; padding-bottom: calc(var(--app-bottom-menu-height) + 16px + env(safe-area-inset-bottom, 0px)); background: #f5f5f5; color: #333; }
header { display: flex; height: 50px; justify-content: space-between; align-items: center; padding: 0 12px; background: #fff; border-bottom: 1px solid #f1f1f1; }
header h1 { margin: 0; color: #222; font-size: 16px; font-weight: 500; }
header button { display: flex; width: 40px; height: 40px; align-items: center; justify-content: center; padding: 0; border: 0; background: transparent; color: #ee4d2d; font-size: 17px; }
header img { width: 19px; height: 19px; object-fit: contain; }
.profile { padding: 18px 20px 20px; background: #ee4d2d; }
.profile-content { min-height: 164px; }
.profile-identity { display: flex; align-items: center; gap: 14px; }
.profile-identity > img { width: 66px; height: 66px; flex: 0 0 66px; border: 2px solid rgba(255, 255, 255, .9); border-radius: 50%; background: #fff; object-fit: contain; }
.profile-user { min-width: 0; margin: 0; }
.profile-user span { display: block; overflow: hidden; color: rgba(255, 255, 255, .78); font-size: 11px; line-height: 16px; text-overflow: ellipsis; white-space: nowrap; }
.profile-user strong { display: block; overflow: hidden; margin-top: 2px; color: #fff; font-size: 19px; font-weight: 600; line-height: 26px; text-overflow: ellipsis; white-space: nowrap; }
.profile-details { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 14px; margin-top: 15px; padding-top: 12px; border-top: 1px solid rgba(255, 255, 255, .26); }
.profile-details p { min-width: 0; margin: 0; }
.profile-details span { display: block; overflow: hidden; color: rgba(255, 255, 255, .76); font-size: 10px; line-height: 14px; text-overflow: ellipsis; white-space: nowrap; }
.profile-details strong { display: block; overflow: hidden; margin-top: 2px; color: #fff; font-size: 13px; font-weight: 600; line-height: 18px; text-overflow: ellipsis; white-space: nowrap; }
@media (max-width: 360px) {
    .profile { padding-right: 18px; padding-left: 18px; }
    .profile-details { gap: 8px 10px; }
}
.wallet-actions { display: grid; grid-template-columns: repeat(2, 1fr); min-height: 88px; background: #fff; border-bottom: 1px solid #ececec; }
.wallet-actions button { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 7px; border: 0; border-right: 1px solid #ededed; background: #fff; color: #333; font-size: 13px; }
.wallet-actions button:last-child { border-right: 0; }
.wallet-actions img { width: 31px; height: 31px; object-fit: contain; }
.menu { margin-top: 10px; background: #fff; }
.menu button { display: flex; width: 100%; min-height: 54px; align-items: center; gap: 14px; padding: 0 16px; border: 0; border-bottom: 1px solid #ededed; background: #fff; color: #333; text-align: left; font-size: 14px; }
.menu button:last-child { border-bottom: 0; }
.menu img { width: 25px; height: 25px; object-fit: contain; }
.menu .entry-icon { width: 25px; flex: 0 0 25px; color: #333; font-size: 23px; text-align: center; }
.menu span { flex: 1; }
.menu .van-icon { color: #b8b8b8; font-size: 14px; }
.menu .van-icon.entry-icon { color: #333; font-size: 23px; }
.support { margin-top: 10px; }
.drawer-mask { position: fixed; z-index: 2000; inset: 0; display: flex; justify-content: flex-end; background: rgba(0, 0, 0, .5); }
.account-drawer { width: 78%; min-height: 100%; background: #fff; box-shadow: -4px 0 12px rgba(0, 0, 0, .08); }
.drawer-close { display: flex; width: 100%; height: 50px; align-items: center; justify-content: flex-end; padding: 0 16px; border: 0; border-bottom: 1px solid #f0f0f0; background: #ee4d2d; color: #fff; font-size: 20px; }
.drawer-item { display: flex; width: 100%; min-height: 58px; align-items: center; gap: 14px; padding: 10px 16px; border: 0; border-bottom: 1px solid #f0f0f0; background: #fff; color: #333; text-align: left; font-size: 14px; line-height: 20px; }
.drawer-item img { width: 27px; height: 27px; flex: 0 0 27px; object-fit: contain; }
.drawer-item span { flex: 1; }
.drawer-item .van-icon { color: #b8b8b8; font-size: 14px; }
.personal-center { background: #f5f5f5; }
header { border-bottom-color: #ececec; }
.profile { padding: 18px 20px; background: #ee4d2d; }
.profile-content { min-height: 98px; }
.profile-content > img { width: 66px; height: 66px; flex-basis: 66px; border-width: 2px; box-shadow: none; }
.wallet-actions { min-height: 82px; }
.wallet-actions button { color: #333; font-size: 13px; }
.wallet-actions img { width: 28px; height: 28px; }
.menu { margin-top: 8px; }
.menu button { min-height: 52px; color: #333; font-size: 14px; }
.menu img { width: 23px; height: 23px; }
.drawer-close { background: #ee4d2d; }
</style>
